import { Data } from "dataclass";
import { TripDto } from "../../../../Global/models/TripDto";

export class ItineraryViewModel extends Data {
  itineraryList: Itinerary[];
}

export class Itinerary extends Data {
  heading: string = "";
  desc: string[] = [];
  img: string = "";
}

export const mapToItineraryViewModel = (
  tripDto: TripDto
): ItineraryViewModel => {
  const itineraryList = tripDto.itinerary;
  const itineraryViewModel = ItineraryViewModel.create({
    itineraryList: itineraryList.map((itinerary) =>
      Itinerary.create({
        heading: itinerary.heading,
        desc: itinerary.desc,
        img: itinerary.img,
      })
    ),
  });

  return itineraryViewModel
};
